import man from "../Assets/man.png"
const Rentals=()=>
{
    const rentaldata=["High-quality Listing","Competitive Pricing","Online presence and marketing","Positive Reviews and guest Satisfaction","Targeted Advertising","Enhance Guest Experience","Partnering with local businesses"]
    return(
        <div className="sm:block lg:flex items-center sm:px-[16px] lg:px-[160px] sm:pt-[30px] lg:pt-[80px] gap-[70px]">
            <img className="sm:hidden lg:block w-[40%]" src={man}/>
            <div>
                <p style={{fontFamily:"Playfair Display"}} className="sm:text-[22px] lg:text-[32px] text-[#C69130] font-[600] sm:leading-[30px] lg:leading-[56px] tracking-[0.5px] sm:mb-[30px] lg:mb-[32px]">Our best practices to earn you more rentals</p>
                <div className="flex flex-col items-center">
                    <img className="sm:block lg:hidden w-full" src={man}/>
                </div>
                <div className="sm:mt-[30px] lg:mt-[0px]">
                {
                    rentaldata?.map((item,index)=>(

                                            <li key={index} style={{fontFamily:"Inter"}} className="text-[16px] text-[#656565] font-[400] leading-[30px] sm:mb-[15px] lg:mb-[15px]">{item}</li>
                                        ))
                }
                </div>
            </div>
        </div>
    )
}
export default Rentals